/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import EditIcon from '@mui/icons-material/Edit';
import EditIcon1 from '@mui/icons-material/EditOff';
import PreviewIcon from '@mui/icons-material/Preview';
// import Paper from '@mui/material/Paper';
import UndoIcon from '@mui/icons-material/Undo';
// import { styled } from '@mui/material/styles';
import TablePagination from '@mui/material/TablePagination';
import { CSVLink } from 'react-csv';
import {
  // Avatar,
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Modal,
  Typography,
  Button,
  TableContainer,
  TableFooter
} from '@material-ui/core';

import Grid from '@mui/material/Grid';
import Loader from 'react-loader-spinner';
import { makeStyles } from '@mui/styles';
import { BaseUrl, endpoints } from '../../utils/factory';
import axios from "axios";
import moment from 'moment';
import { exportToExcel } from 'utils/exportToExcel';

// const Item = styled(Paper)(({ theme }) => ({
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: 'center',
//   color: theme.palette.text.secondary
// }));


// const moment = require('moment');

const useStyles = makeStyles({
  root: {
    backgroundColor: '#000',
    color: '#fff',
    padding: '10px',
    border: 'none',
    borderRadius: '5px',
    textTransform: 'uppercase',
    fontWeight: 'bold'
  }
});
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4
};

const styletable = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 1350,
  bgcolor: 'white',
  border: '2px solid #fff',
  boxShadow: 24,
  p: 4
};

const stylefooter = {
  size: 18
};
const istyle = {
  color: 'red'
};

const csvbutton = {
  color: '#ffffff',
  display: 'block',
  width: '131px',
  height: '37px',
  textAlign: 'center',
  paddingTop: '6px',
  borderRadiusr: '4px',
  position: 'relative',
  backgroundColor: '#000000',
  boxShadow: '0 0 1px 0 rgb(0 0 0 / 31%), 0 2px 2px -2px rgb(0 0 0 / 25%)',
  fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
  fontWeight: '500',
  fontSize: '0.875rem',
  lineHeight: '1.75',
  letterSpacing: '0.02857em',
  textTransform: 'uppercase'
};
const CustomerListResults = ({
  customers,
  // getchilddata,
  flagstatus,
  fromdate,
  todate,
  datesearch,
  bookedfilter,
  loaderflag,
  exportlist,
  handleExportGrid,
  exportflag,
  handleExportGridTwo,
  exportlisttwo,
  exportflagver,
  exportflagverCSV,
  handelCsvButon,
  invoicelistexportcsv,
  ...rest
}) => {
  // console.log('search cu:::::::::::', customers);
  // const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
  const [invoicelist, setInvoicelList] = useState([]);
  const [invoiceviewlist, setInvoiceViewlList] = useState([]);
  const [open, setOpen] = useState(false);
  const [loaderstate, setLoaderstate] = useState(false);
  const [openview, setOpenView] = useState(false);
  // const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);

  const [invoiceid, setInvoiceId] = useState('');
  const [invremarks, setInvRemarks] = useState('');
  const [errormsg, setErrorMsg] = useState(false);
  const [totalcbm, setTotalCbm] = useState(0);
  const [totalbox, setTotalBox] = useState(0);
  const [totalqty, setTotalQty] = useState(0);
  // const [hide, setHide] = useState(true);

  const [saleReturn, setSaleReturn] = useState(0);
  const [standard, setStandard] = useState(0);
  console.log('hello ::::::::', saleReturn, standard);
  const hide = false;
  // const [exportbtnflag, setExportBtnFlag] = useState(false);

  const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
  const [previnvoicelist, setPrevInvoiceList] = useState([]);
  const [singleselectinv, setSingleSelectInv] = useState('0');
  const [openunchecked, setOpenUnchecked] = useState(false);
  const [invreason, setInvreason] = useState('');
  const [updatemsg, setUpdateMsg] = useState(false);
  const [totalinvoice, setTotalInvoice] = useState('0');
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [page, setPage] = useState(0);

  const clientid = localStorage.getItem('trans-userId');
  const clientName = localStorage.getItem('trans-userName');
  const cmp_id = localStorage.getItem('trans-cmp_id');

  // console.log('standard::::::::::saleReturn::::::::::', invoicelist);
  // console.log('standard::::::::::saleReturn::::::::::', totalbox);

  const classes = useStyles();
  // const [open2, setOpen2] = useState(false);

  // const readData = async () => {
  //   try {
  //     axios
  //       .post(`${URL}trans_loaditems`, {
  //         userid: clientid,
  //         qtype: '1',
  //         searchtext: '',
  //         fdate: '',
  //         tdate: '',
  //         headers: {
  //           'Access-Control-Allow-Origin': '*',
  //           'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
  //         }
  //       })
  //       .then((response) => {
  //         if (response.data.d.length > 0) {
  //           // eslint-disable-next-line no-eval
  //           const userdata = eval(response.data.d);
  //           setInvoicelList(userdata);
  //           // getchilddata(userdata);
  //           setPrevInvoiceList(userdata);
  //         } else setInvoicelList([]);
  //       })
  //       .catch((error) => {
  //         console.log('API error', error);
  //       });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const readViewData = async (id) => {
    setInvoiceId(id);
    setTotalCbm(0);
    setTotalBox(0);
    setTotalQty(0);
    try {
      axios
        .post(`${BaseUrl}${endpoints.getOrdersStockTransfers}`, {
          userid: clientid,
          qtype: '2',
          searchtext: id,
          Del_Datefrom: '',
          Del_Dateto: '',
          username: clientName,
          cmp_id: cmp_id,
          delsno: 0,
        })
        .then((response) => {
          if (response.data.length > 0) {
            // eslint-disable-next-line no-eval
            const userdata = response.data;
            setInvoiceViewlList(userdata);
            let totcbm = 0;
            let totqty = 0;
            let totbox = 0;
            let totstdbox = 0;
            let totrtnbox = 0;

            for (let i = 0; i < userdata.length; i++) {
              totcbm = parseFloat(
                parseFloat(totcbm) + parseFloat(userdata[i].TotalCBM)
              );
              totqty = parseFloat(
                parseFloat(totqty) + parseFloat(userdata[i].Itd_qty)
              );

              totbox = parseFloat(
                parseFloat(totbox) + parseFloat(userdata[i].TotalBoxes)
              );

              // console.log('Total::::::::::::::', totcbm);
              // console.log(
              //   'TotalCBM::::::::::::::',
              //   userdata[i].TotalCBM
              // );
              if (userdata[i].DeliveryType === 'Standard') {
                totstdbox = parseFloat(
                  parseFloat(totstdbox) + parseFloat(userdata[i].TotalBoxes)
                );
              }

              if (userdata[i].DeliveryType === 'Sales Return') {
                totrtnbox = parseFloat(
                  parseFloat(totrtnbox) + parseFloat(userdata[i].TotalBoxes)
                );
              }
            }
            // const totalsale = userdata.filter(
            //   (a) => a.DeliveryType === 'Sales Return'
            // );

            // const totalStandard = userdata.filter(
            //   (a) => a.DeliveryType === 'Standard'
            // );
            setSaleReturn(totrtnbox);
            setStandard(totstdbox);
            setTotalCbm(totcbm.toFixed(2));
            setTotalBox(totbox.toFixed(2));
            setTotalQty(totqty.toFixed(2));
          } else setInvoiceViewlList([]);
        })
        .catch((error) => {
          console.log('API error', error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleOpen = (event, id, remarks, type) => {
    setErrorMsg(false);
    setInvoiceId(id);
    setInvRemarks(remarks);
    if (type === 'remarks') setOpen(true);
    else {
      setInvoiceViewlList([]);
      readViewData(id);
      setOpenView(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setOpenView(false);
  };
  const handleRemarksChange = (event) => {
    setInvRemarks(event.target.value);
  };

  useEffect(() => {
    if (flagstatus) {
      setPrevInvoiceList(customers);
      setInvoicelList(customers);
      setTotalInvoice(customers.length);
      setRowsPerPage(20);
      setPage(0);
    } else {
      //  readData();
    }
  }, [customers, flagstatus]);

  useEffect(() => {
    setLoaderstate(loaderflag);
  }, [loaderflag]);
  // const handleSelectDispatch = (event, id) => {
  //   try {
  //     axios
  //       .post(`${URL}trans_updateitems`, {
  //         userid: clientid,
  //         qtype: '2',
  //         invoiceId: id,
  //         remarks: '',
  //         bookstatus: '0',
  //         disstatus: '1',
  //       })
  //       .then((response) => {
  //         // eslint-disable-next-line no-eval
  //         // setInvoicelList(userdata);
  //         console.log(response);
  //         readData();
  //       })
  //       .catch((error) => {
  //         console.log('API error', error);
  //       });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleRemarks = () => {
    setErrorMsg(false);
    try {
      if (invremarks === '') {
        setErrorMsg(true);
      } else {
        setOpen(false);
        // "userid": data.userid,
        // "deldate": data.deldate|| '',
        // "qtype": data.qtype || '',
        // "cmp_id": data.cmp_id,
        // "username": data.username,
        // "isbookedstatus": `${data.bookingstatus}`,
        // "isdispatched": `${data.dispatchstatus}`, 
        // "processid":data.processId||'',
        // "remarks":data.remarks||''
        axios
          .put(`${BaseUrl}${endpoints.getOrdersStockTransfers}`, {
            deldate: "",
            cmp_id: cmp_id,
            username: clientName,
            bookingstatus: '1',
            delsno: 0,
            userid: clientid,
            qtype: 'updateremarks',
            processid: invoiceid,
            remarks: invremarks,
            isbookedstatus: '1',
            isdispatched: '0',
          })
          .then(() => {
            // eslint-disable-next-line no-eval
            // const userdata = eval(response.data.d);
            // setInvoicelList(userdata);
            // console.log(response.data.d);
            datesearch(fromdate, todate, 2);
          })
          .catch((error) => {
            console.log('API error', error);
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectAll = (event) => {
    let newSelectedCustomerIds;
    // console.log('Prev Invoice:::::::::::', invoicelist);
    if (event.target.checked) {
      newSelectedCustomerIds = invoicelist.map((customer) => customer.inv_id);
      setSelectedCustomerIds(newSelectedCustomerIds);
      for (let i = 0; i < newSelectedCustomerIds.length; i++) {
        for (let z = 0; z < invoicelist.length; z++) {
          if (invoicelist[z].inv_id === newSelectedCustomerIds[i]) {
            invoicelist[z].Itd_IsTransBooked = 'Booked';
            invoicelist[z].chkTransBooked = 'Yes';
          }
        }
      }
    } else {
      newSelectedCustomerIds = [];
      console.log('invoicelist Invoice:::::::::::', previnvoicelist);
      setSelectedCustomerIds(newSelectedCustomerIds);
      // console.log('in uss:::::::::', customers);

      // console.log('Prev Invoice:::::::::::', previnvoicelist);
      // console.log('Prev Invoice:::::::::::', invoicelist);

      for (let z = 0; z < invoicelist.length; z++) {
        invoicelist[z].Itd_IsTransBooked = invoicelist[z].Itd_IsTransBookedold;
        invoicelist[z].chkTransBooked = invoicelist[z].chkTransBookedold;
      }

      // setInvoicelList(previnvoicelist);
    }
  };
  const handleSelectSingle = (event, invoiceidsingle) => {
    let newSelectedCustomerIds;
    if (event.target.checked) {
      newSelectedCustomerIds = invoicelist.map((customer) => customer.inv_id);
      setSelectedCustomerIds(newSelectedCustomerIds);
      for (let i = 0; i < newSelectedCustomerIds.length; i++) {
        for (let z = 0; z < invoicelist.length; z++) {
          if (
            // eslint-disable-next-line operator-linebreak
            invoicelist[z].inv_id === newSelectedCustomerIds[i] &&
            invoicelist[z].inv_id === invoiceidsingle
          ) {
            invoicelist[z].chkTransBooked = 'Yes';
            invoicelist[z].Itd_IsTransBooked = 'Booked';
          }
        }
      }
    } else {
      newSelectedCustomerIds = [];
      setSelectedCustomerIds(newSelectedCustomerIds);

      for (let z = 0; z < invoicelist.length; z++) {

        if (invoicelist[z].inv_id === invoiceidsingle) {

          // eslint-disable-next-line operator-linebreak
          invoicelist[z].Itd_IsTransBooked =
            invoicelist[z].Itd_IsTransBookedold;
          invoicelist[z].chkTransBooked = invoicelist[z].chkTransBookedold;
        }
      }

      // setInvoicelList(previnvoicelist);
    }
  };
  const handleUpdateSelected = () => {
    setLoaderstate(true);
    setUpdateMsg(false);
    let selectedProcessIds = [];
    for (let z = 0; z < invoicelist.length; z++) {
      if (invoicelist[z].chkTransBooked === 'Yes') {
        // eslint-disable-next-line prefer-template
        selectedProcessIds[z] = invoicelist[z].inv_id;
      }
    }
    // console.log(selectedinv);
    setErrorMsg(false);
    try {
      setOpen(false);
      axios
        .put(`${BaseUrl}${endpoints.getOrdersStockTransfers}`, {
          userid: clientid,
          qtype: 'book',
          selectedProcessIds: selectedProcessIds,
          remarks: '',
          deldate: "",
          cmp_id: cmp_id,
          username: clientName,
          delsno: 0,
          isbookedstatus: '1',
          isdispatched: '0',
        })
        .then(() => {
          // eslint-disable-next-line no-eval
          // const userdata = eval(response.data.d);
          // setInvoicelList(userdata);
          // console.log(response.data.d);
          datesearch(fromdate, todate, bookedfilter);
          setLoaderstate(false);
          setUpdateMsg(true);
        })
        .catch((error) => {
          console.log('API error', error);
        });
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        setUpdateMsg(false);
      }, 5000);
    }
  };

  const handlebetaversiontwo = () => {
    handleExportGridTwo();
  };

  const handleExportClick = () => {
    // setExportBtnFlag(true);
    handleExportGrid();
  };

  useEffect(() => {
    // setExportBtnFlag(exportflag);
    console.log('Export Flag', exportflag);
  }, [exportflag]);

  const handleUncheckedSingleFinal = (event, invoiceidsingle) => {
    // eslint-disable-next-line prefer-const
    let newSelectedCustomerIds = invoicelist.map((customer) => customer.inv_id);

    setSelectedCustomerIds(newSelectedCustomerIds);
    for (let i = 0; i < newSelectedCustomerIds.length; i++) {
      for (let z = 0; z < invoicelist.length; z++) {
        if (
          invoicelist[z].inv_id === newSelectedCustomerIds[i] &&
          invoicelist[z].inv_id === invoiceidsingle
        ) {
          invoicelist[z].Itd_IsTransBooked = 'Pending';
          invoicelist[z].chkTransBooked = 'No';
        }
      }
    }
  };

  const handleUncheckedSingle = (event, invoiceidsingle) => {
    setSingleSelectInv(invoiceidsingle);
    setOpenUnchecked(true);
  };
  const handleCloseUnchecked = () => {
    setOpen(false);
    setOpenView(false);
    setOpenUnchecked(false);
  };

  const handleReasonChange = (event) => {
    setInvreason(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleReason = () => {
    setErrorMsg(false);
    try {
      if (invreason === '') {
        setErrorMsg(true);
      } else {
        setOpenUnchecked(false);
        axios
          .put(`${BaseUrl}${endpoints.getOrdersStockTransfers}`, {
            userid: clientid,
            qtype: 'book',
            remarks: invreason,
            selectedProcessIds: [singleselectinv],
            deldate: "",
            cmp_id: cmp_id,
            username: clientName,
            delsno: 0,
            isbookedstatus: '0',
            isdispatched: '0',

          })
          .then((response) => {
            // eslint-disable-next-line no-eval
            // const userdata = eval(response.data.d);
            // setInvoicelList(userdata);
            console.log(response.data);
            // datesearch(fromdate, todate);
            handleUncheckedSingleFinal('', singleselectinv);
            datesearch(fromdate, todate, bookedfilter);
          })
          .catch((error) => {
            console.log('API error', error);
          });
      }
    } catch (error) {
      console.log(error);
    }
  };
  // console.log(':::::::::::::::::::hello:::::::::::::', invoicelist.length);

  return (
    <Card {...rest}>
      <PerfectScrollbar>
        <Box sx={{ flexGrow: 1 }} style={{ display: 'block' }}>
          <Grid
            container
            spacing={2}
            style={{ marginTop: '10px', paddingLeft: '10px' }}
          >
            <Grid item xs={1}>
              <Button variant="contained" onClick={handleUpdateSelected}>
                Book
              </Button>
            </Grid>
            {hide && (
              <Grid item xs={1}>
                {exportflag && (
                  <Button variant="contained" onClick={handleExportClick}>
                    Export
                  </Button>
                )}
                {!exportflag && (
                  <></>
                )}
              </Grid>
            )}

            <Grid item xs={1.3}>
              {exportflagver && (
                <Button variant="contained" onClick={handlebetaversiontwo}>
                  Export (Beta)
                </Button>
              )}
              {!exportflagver && (
                <Button variant="contained" onClick={()=>exportToExcel(exportlisttwo)}>
                  Download (Beta)
                </Button>
              )}
            </Grid>

            {hide && (
              <Grid item xs={1.5}>
                {exportflagverCSV && (
                  <Button variant="contained" onClick={handelCsvButon}>
                    Export (Csv)
                  </Button>
                )}
                {!exportflagverCSV && (
                  <CSVLink style={csvbutton} data={invoicelistexportcsv}>
                    Download CSV
                  </CSVLink>
                )}
              </Grid>
            )}
            <Loader
              visible={loaderstate}
              type="Puff"
              color="#00BFFF"
              height={45}
              width={45}
              timeout={300000}
            />

            <Box
              sx={{ flexGrow: 1 }}
              style={{
                marginTop: '24px',
                fontWeight: 'bolder'
              }}
            >
              {loaderstate === false && invoicelist && invoicelist.length === 0
                ? 'Sorry there is no records for this filter'
                : ''}
            </Box>
            {/* {console.log(
              '???????????????????????????????????????',
              loaderstate
            )} */}

            {/* <Loader
              visible={loaderstate}
              type="Puff"
              color="#00BFFF"
              height={45}
              width={45}
              timeout={300000}
            /> */}
            {updatemsg && (
              <Box
                sx={{ flexGrow: 1 }}
                style={{
                  marginTop: '24px'
                }}
              >
                {' '}
                Successfully Updated!
              </Box>
            )}

            <Box
              sx={{ flexGrow: 1 }}
              style={{
                marginTop: '24px',
                textAlign: 'right',
                paddingRight: '30px',
                fontWeight: '600',
                fontSize: '20px'
              }}
            >
              {' '}
              Total Records {totalinvoice}
            </Box>
            {/* )} */}
          </Grid>
        </Box>
        <Box
          sx={{ flexGrow: 1 }}
          style={{
            marginTop: '24px',
            color: 'red',
            fontWeight: 'bolder',
            marginLeft: '10px'
          }}
        >
          {' '}
          For best download results, select date range between 1 to 5 days.
        </Box>
        <Box sx={{ minWidth: 1350 }}>
          <Table id="emp">
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={selectedCustomerIds.length === invoicelist.length}
                    color="primary"
                    indeterminate={
                      selectedCustomerIds.length > 0 &&
                      selectedCustomerIds.length < invoicelist.length
                    }
                    onChange={handleSelectAll}
                  />
                </TableCell>

                <TableCell>Transfer Id</TableCell>
                <TableCell>Outlet From</TableCell>
                <TableCell>Transfer To</TableCell>
                <TableCell>Delivery Type</TableCell>
                <TableCell>Delivery Date</TableCell>
                <TableCell>Booked Status</TableCell>
                <TableCell>Comment</TableCell>
                <TableCell>Created By</TableCell>
                <TableCell>Dispatch</TableCell>
                <TableCell>Remarks</TableCell>
                <TableCell>View</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invoicelist
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((customer, index) => (
                  <TableRow hover key={index[0]}>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={customer.chkTransBooked == 'Yes'}
                        onClick={
                          (event) =>
                            handleSelectSingle(event, customer.inv_id)
                        }
                      />
                      {customer.chkTransBooked == 'Yes' ? (
                        <UndoIcon
                          style={{ cursor: 'pointer', marginLeft: '8px' }}
                          onClick={
                            (event) =>
                              handleUncheckedSingle(event, customer.inv_id)
                          }
                        />
                      ) : null}
                    </TableCell>
                    <TableCell>{customer.inv_id}</TableCell>
                    <TableCell>{customer.Outletfrom}</TableCell>
                    <TableCell>{customer.TransferTo}</TableCell>
                    <TableCell>{customer.DeliveryType}</TableCell>
                    <TableCell>{
                      moment(customer.ST_deldate, 'DD-MM-YYYY').isValid()
                        ? moment(customer.ST_deldate, 'DD-MM-YYYY').format('DD/MM/YYYY')
                        : ''}</TableCell>
                    {/* <TableCell>{customer.Status1 == 0 ? 'Initiated' : customer.Status1 == 1 ? 'Assigned For Picking' : customer.Status1 == 2 ? "Ready For Dispatch" : customer.Status1 == 3 ? 'Area Assigned' : customer.Status1 == 4 ? 'Dispatched' : customer.Status1 == 5 ? 'Fulfilled' : customer.Status1 == 6 ? 'Cancelled' : null}</TableCell> */}
                    <TableCell>{customer.isbooked}</TableCell>
                    <TableCell>{customer.remarks}</TableCell>
                    <TableCell>{customer.Usr_name}</TableCell>

                    <TableCell padding="checkbox">
                      <Checkbox
                        disabled
                        checked={customer.Itd_IsTransDispatched === 'Yes'}
                        value="true"
                      />
                    </TableCell>

                    {customer.chkTransBooked == 'Yes' || customer.DeliveryType == 'Labour Hire' ?
                      (
                        <TableCell>
                          <EditIcon1 />
                        </TableCell>
                      )
                      :
                      (
                        <TableCell
                          onClick={
                            (event) =>
                              handleOpen(
                                event,
                                customer.inv_id,
                                customer.Itd_Trans_Remarks,
                                'remarks'
                              )
                          }
                        >
                          <EditIcon />
                        </TableCell>
                      )}
                    <TableCell
                      onClick={
                        (event) =>
                          // eslint-disable-next-line implicit-arrow-linebreak
                          handleOpen(
                            event,
                            customer.inv_id,
                            customer.Itd_Trans_Remarks,
                            'view'
                          )
                        // eslint-disable-next-line react/jsx-curly-newline
                      }
                    >
                      <PreviewIcon />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>

            <TableRow>
              <TableCell colSpan={10}>
                <TablePagination
                  rowsPerPageOptions={[20, 50, 100, 200]}
                  component="div"
                  count={invoicelist.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableCell>
            </TableRow>
          </Table>
          <table id="emp1" style={{ display: 'none' }}>
            <thead>
              <tr>
                <th>Invoice Id</th>
                <th> DeliveryComments</th>
                <th>ServiceDescriptions</th>
                <th>GoodSummary</th>
                <th>Qty</th>
                <th>Boxes</th>
                <th>CBM</th>
                <th>PickupName</th>
                <th>PickupStreet</th>
                <th>PickupSuburb</th>
                <th>PickupPostCode</th>
                <th>PickupState</th>
                <th>DeliveryName</th>
                <th>DeliveryStreet</th>
                <th>DeliverySuburb</th>
                <th>DeliveryPostCode</th>
                <th>DeliveryState</th>
                <th>DeliveryCharge</th>
                <th>Phone</th>
                <th>Booked Status</th>

                {/* <th>Contact Details</th>
                <th>Phone</th>
                <th>Email</th>
                <th>State</th>
                <th>Delivery Charges</th>
                <th>Delivery Date</th>
                <th>Comments</th>
                <th>Remarks</th>
                <th>Booked</th>
                <th>Dispatched</th>
                <th>CBM</th>
                <th>TotalBoxes</th>
                <th>Barcode</th>
                <th>Qty</th>
                <th>Invoice Status</th> */}
              </tr>
            </thead>
            <tbody>
              {exportlist.map((customer) => (
                <tr key={customer.sno}>
                  <td>{customer.invoiceId}</td>
                  <td>{customer.DeliveryComments}</td>
                  <td>{customer.ServiceDescription}</td>
                  <td>{customer.GoodsSummary}</td>
                  <td>{customer.Qty}</td>
                  <td>{customer.Boxes}</td>
                  <td>{customer.CBM}</td>
                  <td>{customer.PickupName}</td>
                  <td>{customer.PickupStreet}</td>
                  <td>{customer.PickupSuburb}</td>
                  <td>{customer.PickupPostcode}</td>
                  <td>{customer.PickupState}</td>
                  <td>{customer.DelivaryName}</td>
                  <td>{customer.DelivaryStreet}</td>
                  <td>{customer.DelivarySuburb}</td>
                  <td>{customer.DelivaryPostcode}</td>
                  <td>{customer.DelivaryState}</td>
                  <td>{customer.DelivaryCharges}</td>
                  <td>{customer.Phone}</td>
                  <td>{customer.Itd_IsTransBooked}</td>

                  {/* <td>{customer.ContactDtls}</td>
                  <td>{customer.contact}</td>
                  <td>{customer.Email}</td>
                  <td>{customer.State}</td>
                  <td>{customer.DelCharge}</td>
                  <td>{customer.DelDate}</td>
                  <td>{customer.Comments}</td>
                  <td>{customer.Remarks}</td>
                  <td>{customer.Booked}</td>
                  <td>{customer.Dispatched}</td>
                  <td>{customer.CBM}</td>
                  <td>{customer.TotalBoxes}</td>
                  <td>{customer.Barcode}</td>
                  <td>{customer.Qty}</td>
                  <td>{customer.Invoicestatus}</td> */}
                </tr>
              ))}
            </tbody>
          </table>

          <table
            id="emp2"
            style={{ display: 'none' }}
            cellSpacing="5"
            cellPadding="5"
          >
            <thead>
              <tr bgcolor="skyblue" style={{ border: '1px solid black' }}>
                <th>Ito Number</th>
                <th> Delivery Date</th>
                <th>Boxes</th>
                <th>Cbm</th>
                <th>Goods Summary</th>
                <th>Qty</th>
                <th>Source</th>
                <th>Destination</th>
                <th>Product Type</th>
                <th>Delivery Charges</th>
                {/* <th>Delivery Mode</th> */}
                {/* <th>Order At</th> */}
                {/* <th>Delivery Company</th> */}
                <th>Delivery Type</th>
                <th>Weight</th>
              </tr>
            </thead>
            <tbody>
              {exportlisttwo.map((customer) => (
                <tr key={customer.sno}>
                  <td>{customer.ito_nm}</td>
                  <td>{customer.dlvry_date}</td>
                  <td>{customer.boxes}</td>
                  <td>{customer.cbm}</td>
                  <td>{customer.goodssummary}</td>
                  <td>{customer.qty}</td>
                  <td>{customer.source}</td>
                  <td>{customer.dstinatn}</td>
                  <td>{customer.product_typ}</td>
                  <td>{customer.dlvry_chrgs}</td>
                  {/* <td>{customer.dlvry_mode}</td> */}
                  {/* <td>{customer.ordr_at}</td> */}
                  {/* <td>{customer.dlvrycmpny}</td> */}
                  <td>{customer.dlvry_typ}</td>
                  <td>{customer.Itemweight}</td>

                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      </PerfectScrollbar>
      {/* Remarks model */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {/* <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
          ></Typography> */}
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label="Remarks"
              multiline
              rows={8}
              defaultValue={invremarks}
              columns={20}
              onChange={handleRemarksChange}
            />
            {errormsg && (
              <Typography sx={istyle}>Please enter remarks </Typography>
            )}
          </Typography>
          <Typography id="modal-modal-footer" sx={{ mt: 2 }}>
            <Button variant="contained" onClick={handleRemarks}>
              Save Remarks
            </Button>
          </Typography>
        </Box>
      </Modal>

      {/* view data model */}
      <Modal
        open={openview}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        contentStyle={{ width: '800%', maxWidth: 'none' }}
      >
        <Box sx={styletable}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Transfer Id {invoiceid}
            </Typography>
            {/* <Typography id="modal-modal-title" variant="h6" component="h2">
              Items are filtered as per the selected delivery dates
            </Typography> */}
          </div>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Box sx={{ minWidth: 550 }}>
              <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Prd short Desc</TableCell>
                      <TableCell>Bar Code</TableCell>
                      <TableCell>ProductType</TableCell>
                      <TableCell>Qty</TableCell>
                      <TableCell>Total Boxes</TableCell>
                      <TableCell>Total CBM</TableCell>
                      <TableCell>Weight</TableCell>
                      <TableCell>Delivery Type</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invoiceviewlist
                      .sort((a, b) => (a.Bar_barcode > b.Bar_barcode ? 1 : -1))
                      .map((customer, index) => (
                        <TableRow hover key={index[1]}>
                          <TableCell>{customer.Prd_shortdesc}</TableCell>
                          <TableCell>{customer.Bar_barcode}</TableCell>
                          <TableCell>{customer.ProductType}</TableCell>
                          <TableCell>{customer.Itd_qty}</TableCell>
                          <TableCell>{customer.TotalBoxes}</TableCell>
                          <TableCell>{customer.TotalCBM}</TableCell>
                          <TableCell>{customer.Weight}</TableCell>
                          <TableCell>{customer.DeliveryType}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                  <TableFooter>
                    <TableRow sx={stylefooter}>
                      <TableCell colSpan={2}>Total</TableCell>
                      <TableCell>{ }</TableCell>
                      <TableCell>{parseFloat(totalqty)}</TableCell>
                      <TableCell>{parseFloat(totalbox)}</TableCell>
                      <TableCell>{totalcbm}</TableCell>
                      <TableCell>{ }</TableCell>
                    </TableRow>
                    {/* <TableRow
                      sx={stylefooter}
                      style={{ backgroundColor: '#F5F5F5' }}
                    >
                      <TableCell>{}</TableCell>
                      <TableCell
                        colSpan={2}
                        style={{
                          marginTop: '24px',
                          paddingRight: '30px',
                          fontWeight: '600',
                          color: 'black',
                          fontSize: '17px'
                        }}
                      >
                        Total Boxes
                      </TableCell>
                      <TableCell
                        style={{
                          marginTop: '24px',
                          paddingRight: '30px',
                          fontWeight: '600',
                          color: 'black',
                          fontSize: '17px'
                        }}
                      >
                        {saleReturn} Sales Return
                      </TableCell>
                      <TableCell
                        style={{
                          marginTop: '24px',
                          paddingRight: '30px',
                          fontWeight: '600',
                          color: 'black',
                          fontSize: '17px'
                        }}
                      >
                        {standard} Standard
                      </TableCell>
                      <TableCell>{}</TableCell>
                      <TableCell>{}</TableCell>
                    </TableRow> */}
                  </TableFooter>
                </Table>
              </TableContainer>
            </Box>
          </Typography>
          <Typography
            id="modal-modal-footer"
            sx={{ mt: 2 }}
            style={{ textAlign: 'center' }}
          >
            <Button variant="contained" onClick={handleClose}>
              Close
            </Button>
          </Typography>
        </Box>
      </Modal>

      {/* Uncheck reason model */}
      <Modal
        open={openunchecked}
        onClose={handleCloseUnchecked}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {/* <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
          ></Typography> */}
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label="Reason"
              multiline
              rows={8}
              defaultValue={invremarks}
              columns={20}
              onChange={handleReasonChange}
            />
            {errormsg && (
              <Typography sx={istyle}>Please enter reason </Typography>
            )}
          </Typography>
          <Typography id="modal-modal-footer" sx={{ mt: 2 }}>
            <Button variant="contained" onClick={handleReason}>
              Save Reason
            </Button>

            <Button
              style={{ marginLeft: '5px' }}
              variant="contained"
              onClick={handleCloseUnchecked}
            >
              Close
            </Button>
          </Typography>
        </Box>
      </Modal>
    </Card>
  );
};

CustomerListResults.propTypes = {
  customers: PropTypes.array.isRequired
};

export default CustomerListResults;
